export default __webpack_public_path__ + "static/media/matka.3937d5cb.svg";